import React__default from 'react';
import { Icon } from '@grandvisionhq/icons';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';

const getPaymentMethodIcon = (method)=>{
    switch(method){
        case PaymentMethod.BANCONTACT_CARD:
        case PaymentMethod.BANCONTACT_MOBILE:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "bancontact",
                    name: "bancontact",
                    width: 54,
                    height: 33,
                    viewBox: "1 0 54 33"
                }), 
            ];
        case PaymentMethod.CASH_ON_DELIVERY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "cashOnDelivery",
                    name: "cash-on-delivery"
                })
            ];
        case PaymentMethod.IDEAL:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "ideal",
                    name: "ideal",
                    viewBox: "0 0 26 23",
                    width: 26,
                    height: 23
                })
            ];
        case PaymentMethod.KLARNA:
        case PaymentMethod.KLARNA_ACCOUNT:
        case PaymentMethod.KLARNA_PAY_NOW:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "klarna",
                    name: "klarna",
                    viewBox: "0 0 45 25",
                    width: 60,
                    height: 33
                })
            ];
        case PaymentMethod.MBWAY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "mbway",
                    name: "mbway",
                    viewBox: "18 0 54 48",
                    width: 60,
                    height: 48
                })
            ];
        case PaymentMethod.MOBILE_PAY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "mobilepay",
                    name: "mobilepay",
                    viewBox: "0 0 40 26",
                    width: 40,
                    height: 26
                })
            ];
        case PaymentMethod.MULTIBANCO:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "multibanco",
                    name: "multibanco",
                    viewBox: "-24 0 56 64",
                    width: 56,
                    height: 64
                }), 
            ];
        case PaymentMethod.ONEY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "oney",
                    name: "oney",
                    viewBox: "0 0 113.5 36.5",
                    width: 32,
                    height: 24
                })
            ];
        case PaymentMethod.PAYPAL:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "paypal",
                    name: "paypal",
                    viewBox: "-2 4 48 16",
                    width: 48,
                    height: 24
                })
            ];
        case PaymentMethod.SEPA_DIRECT_DEBIT:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "sepa",
                    name: "sepa",
                    viewBox: "0 0 32 24",
                    width: 32,
                    height: 24
                })
            ];
        case PaymentMethod.SWISH:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "swish",
                    name: "swish",
                    viewBox: "10 0 70 34",
                    width: 70,
                    height: 40
                })
            ];
        case PaymentMethod.APPLE_PAY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "apple",
                    name: "apple",
                    viewBox: "0 0 32 32",
                    width: 32,
                    height: 32
                })
            ];
        default:
            return undefined;
    }
};

export { getPaymentMethodIcon };
//# sourceMappingURL=get-payment-method-icon.js.map
